import { render, staticRenderFns } from "./AppCallback.vue?vue&type=template&id=b64d456e&scoped=true"
import script from "./AppCallback.vue?vue&type=script&lang=js"
export * from "./AppCallback.vue?vue&type=script&lang=js"
import style0 from "./AppCallback.vue?vue&type=style&index=0&id=b64d456e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64d456e",
  null
  
)

export default component.exports